class ThemeLoader extends HTMLElement {
  isGlobal = false;
  static classes = {
    active: 'd-flex',
    hidden: 'd-none',
  }
  
  connectedCallback() {
    this.isGlobal = this.dataset.global !== undefined;

    if(this.isGlobal) {
      window.onpageshow = () => {
        this.hide();
      }
      window.onpagehide = () => {
        this.hide();
      }
    }
  }
  
  show = () => {
    this.classList.remove(ThemeLoader.classes.hidden);
    this.classList.add(ThemeLoader.classes.active);
  }

  hide = () => {
    this.classList.remove(ThemeLoader.classes.active);
    this.classList.add(ThemeLoader.classes.hidden);
  }
}
if (!window.customElements.get("theme-loader")) {
  window.customElements.define("theme-loader", ThemeLoader);
}

class ReadMore extends HTMLElement {
  expanded; expandible; link; text;
  static classes = {
    expanded: 'expanded',
    link: 'fw-bold d-block mt-2 text-decoration-underline'
  }

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.text = this.querySelector(':scope > div');
    this.expanded = false;
    this.expandible = this.text.scrollHeight > this.text.clientHeight;
    if(this.expandible){
      this.addLink();
    }
  }

  addLink = () => {
    this.link = document.createElement('a');
    this.link.setAttribute('href', '#');
    this.link.innerText = this.dataset.moreText;
    ReadMore.classes.link.split(' ').forEach(c => {
      this.link.classList.add(c);
    });
    this.link.addEventListener('click', (e) => {
      this.toggle(e);
    });
    this.appendChild(this.link);
  }

  toggle = (e) => {
    if(e != undefined)
      e.preventDefault();
    if(this.expanded)
      this.close();
    else
      this.open();
  }

  open = () => {
    this.classList.add(ReadMore.classes.expanded);
    this.link.innerText = this.dataset.lessText;
    this.expanded = true;
  }

  close = () => {
    this.classList.remove(ReadMore.classes.expanded);
    this.link.innerText = this.dataset.moreText;
    this.expanded = false;
  }
}
if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}

class ThemeHeader extends HTMLElement {
  transparentClass; normalClass; canTransparent;
  static offset = 100;
  static els = {
    megamenu: 'theme-megamenu'
  }

  constructor() {
    super();
    this.transparentClass = this.dataset.transparent != undefined ? this.dataset.transparent.split(' ') : [];
    this.normalClass = this.dataset.normal != undefined ? this.dataset.normal.split(' ') : [];
    this.megamenus = this.querySelectorAll(ThemeHeader.els.megamenu);
    this.canTransparent = this.transparentClass.length > 0;
    this.init();
  }

  init = () => {
    if(this.transparentClass.length > 0){
      this.checkBg();
      window.addEventListener('scroll', () => this.checkBg());
      this.addEventListener('mouseover', () => this.unsetTransparent());
      this.megamenus.forEach(el => { 
        el.addEventListener(Utils.E_MEGAMENU_SHOW, () => {
          this.canTransparent = false;
          this.unsetTransparent();
        });
        el.addEventListener(Utils.E_MEGAMENU_HIDE, () => {
          this.canTransparent = !document.querySelectorAll('theme-megamenu.show').length;
          this.checkBg();
        });
      });
    }
    this.addEventListener('mouseleave', () => {
      if(this.transparentClass.length > 0){
        this.checkBg();
      }
      this.closeMegamenu();
    });
  }

  checkBg = () => {
    if(window.scrollY < ThemeHeader.offset) {
      this.setTransparent();
    } else {
      this.unsetTransparent();
    }
  }

  closeMegamenu = () => {
    this.megamenus.forEach(el => {
      el.hide();
    });
  } 

  setTransparent = () => {
    if(this.canTransparent){
      this.transparentClass.forEach(className => {
        this.classList.add(className);
      });
      this.normalClass.forEach(className => {
        this.classList.remove(className);
      });
    }
  }

  unsetTransparent = () => {
    this.transparentClass.forEach(className => {
      this.classList.remove(className);
    });
    this.normalClass.forEach(className => {
      this.classList.add(className);
    });
  }
}
if (!window.customElements.get("theme-header")) {
  window.customElements.define("theme-header", ThemeHeader);
}

class MobilePanel extends HTMLElement {
  static classes = {
    show: ['active']
  }

  connectedCallback() {
    this.main = document.querySelector('#main-mobile');
  }

  show = () => {
    MobilePanel.hideAll();
    this.main.classList.add('d-none');
    MobilePanel.classes.show.forEach(className => {
      this.classList.add(className);
    });
  }

  hide = () => {
    this.main.classList.remove('d-none');
    MobilePanel.classes.show.forEach(className => {
      this.classList.remove(className);
    });
  }

  static hideAll = () => {
    document.querySelectorAll('mobile-panel').forEach(el => {
      el.hide();
    });
  }
}
if (!window.customElements.get("mobile-panel")) {
  window.customElements.define("mobile-panel", MobilePanel);
}

class MobileBtn extends HTMLElement {
  panel;

  constructor() {
    super();
    this.panel = document.querySelector(this.dataset.target);
    this.init();
  }

  init = () => {
    if(this.panel != undefined) {
      this.addEventListener('click', () => this.panel.show());
    }
    if(this.dataset.close != undefined){
      this.addEventListener('click', () => MobilePanel.hideAll());
    }
  }
}
if (!window.customElements.get("mobile-btn")) {
  window.customElements.define("mobile-btn", MobileBtn);
}

class ScrollingText extends HTMLElement {
  displayed;

  connectedCallback() {
    this.displayed = getComputedStyle(document.documentElement).getPropertyValue("--marquee-elements-displayed");
    this.init();
  }

  init = () => {
    document.documentElement.style.setProperty("--marquee-elements", this.children.length);
    for(var i=0; i<this.displayed; i++){
      this.appendChild(this.children[i].cloneNode(true));
    }
  }
}
if (!window.customElements.get("scrolling-text")) {
  window.customElements.define("scrolling-text", ScrollingText);
}

class ThemeMegamenu extends HTMLElement {

  connectedCallback() {
    this.clickoutEvent = this.clickout.bind(this);
    this.querySelectorAll("[data-level]").forEach((el) => {
      el.addEventListener('click', () => this.menuClick(el));
    });
  }

  menuClick = (el) => {
    const data = {label: el.innerText, level: el.dataset.level, parents: el.dataset.parents.split(',')};
    Shopify.analytics.publish(Utils.E_MENU_CLICK, data);
    window.dispatchEvent(new CustomEvent(Utils.E_MENU_CLICK, { detail: data }));
  }

  clickout = (e) => {
    if (!this.contains(e.target) && this.classList.contains('show') && !e.target.closest('megamenu-link')) {
      this.hide();
    }
  }

  show = () => {
    document.addEventListener('click', this.clickoutEvent, false);
    document.querySelectorAll('theme-megamenu').forEach(el => {
      el.hide();
    });
    this.classList.add('show');
    this.dispatchEvent(new CustomEvent(Utils.E_MEGAMENU_SHOW));
  }

  hide = () => {
    if(this.classList.contains('show')){
      this.classList.remove('show');
      this.dispatchEvent(new CustomEvent(Utils.E_MEGAMENU_HIDE));
      document.removeEventListener('click', this.clickoutEvent, false);
    }
  }
}
if (!window.customElements.get("theme-megamenu")) {
  window.customElements.define("theme-megamenu", ThemeMegamenu);
}

class MegamenuLink extends HTMLElement {
  megamenu;

  connectedCallback() {
    this.megamenu = document.querySelector(this.dataset.megamenu);
    this.init();
  }

  init = () => {
    if(this.megamenu != undefined){
      this.addEventListener('mouseover', () => this.show());
      this.addEventListener('click', () => this.clickmenu());

      this.megamenu.addEventListener(Utils.E_MEGAMENU_SHOW, () => {
        this.classList.add('active');
      });
      this.megamenu.addEventListener(Utils.E_MEGAMENU_HIDE, () => {
        this.classList.remove('active');
      });
    }
  }

  clickmenu = () => {
    const data = {label: this.innerText, level: 1};
    Shopify.analytics.publish(Utils.E_MENU_CLICK, data);
    window.dispatchEvent(new CustomEvent(Utils.E_MENU_CLICK, { detail: data }));
  }

  show = () => {
    this.megamenu.show();
  }

}
if (!window.customElements.get("megamenu-link")) {
  window.customElements.define("megamenu-link", MegamenuLink);
}

class VideoControls extends HTMLElement {
  video; overlay;

  connectedCallback() {
    this.video = this.querySelector('video');
    this.overlay = this.querySelector('[data-overlay]');
    this.init();
  }

  init = () => {
    if(this.overlay != undefined){
      this.overlay.addEventListener('click', () => this.toggle());
    }
    this.video.addEventListener('play', () => this.played());
    this.video.addEventListener('pause', () => this.paused());
  }

  play = () => {
    this.video.play();
  }

  pause = () => {
    this.video.pause();
  }

  toggle = () => {
    if(this.video.paused)
      this.play();
    else
      this.pause();
  }

  played = () => {
    if(this.overlay != undefined){
      this.overlay.classList.add('d-none');
    }
  }

  paused = () => {
    if(this.overlay != undefined){
      this.overlay.classList.remove('d-none');
    }
  }
}
if (!window.customElements.get("video-controls")) {
  window.customElements.define("video-controls", VideoControls);
}

class ProductList extends HTMLElement {
  data;

  connectedCallback() {
    this.data = JSON.parse(this.querySelector('script[data-describe="product-list"]').innerText);
    this.init();
  }

  init = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          window.dispatchEvent(new CustomEvent(Utils.E_LIST_VIEWED, { detail: this.data }));
          Shopify.analytics.publish(Utils.E_LIST_VIEWED, this.data);
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(this);
    this.querySelectorAll('product-card').forEach((el) => {
      el.addEventListener(Utils.E_PRODUCT_CLICKED, (e) => {
        const data = {list: this.data, product: e.detail};
        Shopify.analytics.publish(Utils.E_CAROUSEL_CLICK, data);
        window.dispatchEvent(new CustomEvent(Utils.E_CAROUSEL_CLICK, {detail: data}));
      });
    });
  }
}
if (!window.customElements.get("product-list")) {
  window.customElements.define("product-list", ProductList);
}

class SocialIcons extends HTMLElement {

  connectedCallback() {
    this.querySelectorAll('a').forEach((el) => {
      el.addEventListener('click', () => Shopify.analytics.publish(Utils.E_SOCIAL_CLICK, {label: el.getAttribute('aria-label')}));
    });
  }
}
if (!window.customElements.get("social-icons")) {
  window.customElements.define("social-icons", SocialIcons);
}

class DynamicSection extends HTMLElement {
  links; data;

  connectedCallback() {
    this.links = this.querySelectorAll('a,button');
    this.data = {
      label: this.dataset.name,
      pageType: this.dataset.pageType,
      pageName: this.dataset.pageName
    }
    this.init();
  }

  init = () => {
    this.setLinks();
  }

  setObserver = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          Shopify.analytics.publish(Utils.E_BANNER_VIEW, this.data);
          window.dispatchEvent(new CustomEvent(Utils.E_BANNER_VIEW, { detail: this.data }));
          this.dispatchEvent(new CustomEvent(Utils.E_BANNER_VIEW, { detail: this.data }));
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(this);
  }

  setLinks = () => {
    this.links.forEach((el) => {
      el.addEventListener('click', () => {
        const linkData = this.data;
        linkData.cta = el.getAttribute('aria-label') || el.innerText;
        linkData.url = el.href;
        Shopify.analytics.publish(Utils.E_BANNER_CLICK, linkData);
        window.dispatchEvent(new CustomEvent(Utils.E_BANNER_CLICK, { detail: linkData }));
      });
    });
  }
}
if (!window.customElements.get("dynamic-section")) {
  window.customElements.define("dynamic-section", DynamicSection);
}

class AnnouncementBar extends HTMLElement {
  links;

  connectedCallback() {
    this.links = this.querySelectorAll('[data-link]');
    this.init();
  }

  init = () => {
    this.links.forEach((el) => {
      el.addEventListener('click', () => {
        const data = {
          label: el.dataset.link
        };
        Shopify.analytics.publish(Utils.E_ANNOUNCEMENT_CLICK, data);
        window.dispatchEvent(new CustomEvent(Utils.E_ANNOUNCEMENT_CLICK, { detail: data }));
      });
    });
  }
}
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

class FooterMain extends HTMLElement {
  links;

  connectedCallback() {
    this.links = this.querySelectorAll('a');
    this.init();
  }

  init = () => {
    this.links.forEach((el) => {
      el.addEventListener('click', () => {
        const data = {
          label: el.innerText,
          page: this.dataset.page
        };
        if(el.dataset.menu){
          data.menu = el.dataset.menu;
        }
        Shopify.analytics.publish(Utils.E_FOOTER_CLICK, data);
        window.dispatchEvent(new CustomEvent(Utils.E_FOOTER_CLICK, { detail: data }));
      });
    });
  }
}
if (!window.customElements.get("footer-main")) {
  window.customElements.define("footer-main", FooterMain);
}

/* al click su questo componente copia il testo in data-text o il contenuto. se gli si passa un toast di bootstrap lo mostra (tipo "codice copiato!") */
class CopyClick extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', () => this.copy());
  }

  copy = () => {
    navigator.clipboard.writeText(this.dataset.text || this.textContent);
    this.feedback();
  }

  feedback = () => {
    if(this.dataset.toast){
      this.toast();
    } else if (this.dataset.popover){
      this.popover();
    }
  }

  popover = () => {
    let popover = this.dataset.popover ? document.querySelector(this.dataset.popover) : null;
    if(popover){
      popover = new bootstrap.Popover(popover);
      popover.show();
      setTimeout(() => {
        popover.dispose();
      }, 2000);
    }
  }

  toast = () => {
    let toast = this.dataset.toast ? document.querySelector(this.dataset.toast) : null;
    if(toast){
      toast = bootstrap.Toast.getOrCreateInstance(toast);
      toast.show();
    }
  }

}
if (!window.customElements.get("copy-click")) {
  window.customElements.define("copy-click", CopyClick);
}

class ReelSwiper extends ThemeSwiper {
  static SLIDECHANGE = 'reels:change';

  afterInit = () => {
    this.swiper.on('slideChangeTransitionEnd', this.changeEvent.bind(this));
    this.swiper.on('afterInit', this.changeEvent.bind(this));

    const section = this.closest('dynamic-section');
    if(section && this.dataset.reelAutoplay == undefined){
      section.setObserver();
      section.addEventListener(Utils.E_BANNER_VIEW, this.changeEvent.bind(this));
    }
  }

  changeEvent = (e) => {
    const activeSlide = this.querySelector('reel-slide.swiper-slide-active');
    this.querySelectorAll('reel-slide').forEach((el) => {
      el.deactivate();
    });
    if(activeSlide != undefined){
      activeSlide.activate();
    }
  }
}
if (!window.customElements.get("reel-swiper")) {
  window.customElements.define("reel-swiper", ReelSwiper);
}

class ReelSlide extends HTMLElement {
  video; audio; iframe; player;

  connectedCallback()  {
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('iframe');
    this.getPlayer();
    this.audio = this.querySelector('[data-audio]');

    this.video?.addEventListener('volumechange', this.volume.bind(this));
    this.player?.on('volumechange', this.volume.bind(this));
    this.audio.addEventListener('click', this.toggleMuted.bind(this));
    this.volume();
  }

  toggleMuted = () => {
    if(this.video != undefined){
      this.video.muted = !this.video.muted;
    }
    if(this.iframe != undefined){
      this.player.getVolume().then((volume) => {
        this.player.setVolume(volume == 0 ? 1 : 0);
      });
    }
  }

  volume = (e) => {
    if(this.video != undefined){
      if(this.video.muted){
        this.classList.add('muted');
      } else {
        this.classList.remove('muted');
      }
    }
    if(this.iframe != undefined){
      this.player.getVolume().then((volume) => {
        if(volume == 0){
          this.classList.add('muted');
        } else {
          this.classList.remove('muted');
        }
      });
    }
  }

  activate = () => {
    if(this.video){
      this.video.play();
    }
    if(this.iframe){
      this.player.play();
    }
    this.classList.add('active');
  }

  deactivate = () => {
    if(this.video){
      this.video.pause();
    }
    if(this.iframe){
      this.player.pause();
    }
    this.classList.remove('active');
  }

  getPlayer = () => {
    if(!this.player && this.iframe){
      this.player = new Vimeo.Player(this.iframe);
    }
    return this.player;
  }
}
if (!window.customElements.get("reel-slide")) {
  window.customElements.define("reel-slide", ReelSlide);
}